import { SVGProps } from 'react';

const Shuffle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18 22 4-4-4-4m4 4h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45M18 10l4-4-4-4m4 4h-5.973a4 4 0 0 0-3.3 1.7l-5.454 8.6a4 4 0 0 1-3.3 1.7H2M2 6h1.972a4 4 0 0 1 3.6 2.2"
    />
  </svg>
);
export default Shuffle;
